import React from "react";

function SkeletonGroupCard() {
  return (
    <div className="overflow-hidden rounded-[2rem] border border-slate-200 bg-white shadow-xl shadow-slate-200/60 dark:border-white/10 dark:bg-white/[0.05]">
      <div className="h-36 animate-pulse bg-slate-200 dark:bg-white/10" />

      <div className="space-y-4 p-5">
        <div className="grid gap-2 sm:grid-cols-4">
          <div className="h-10 animate-pulse rounded-2xl bg-slate-200 dark:bg-white/10" />
          <div className="h-10 animate-pulse rounded-2xl bg-slate-200 dark:bg-white/10" />
          <div className="h-10 animate-pulse rounded-2xl bg-slate-200 dark:bg-white/10" />
          <div className="h-10 animate-pulse rounded-2xl bg-slate-200 dark:bg-white/10" />
        </div>

        <div className="h-20 animate-pulse rounded-[1.5rem] bg-slate-200 dark:bg-white/10" />
        <div className="h-20 animate-pulse rounded-[1.5rem] bg-slate-200 dark:bg-white/10" />
        <div className="h-20 animate-pulse rounded-[1.5rem] bg-slate-200 dark:bg-white/10" />
      </div>
    </div>
  );
}

function GroupsSkeleton() {
  return (
    <div className="grid gap-5 lg:grid-cols-2">
      <SkeletonGroupCard />
      <SkeletonGroupCard />
    </div>
  );
}

export default GroupsSkeleton;